import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=06929edc&scoped=true"
import script from "./MessageComponent.vue?vue&type=script&lang=js"
export * from "./MessageComponent.vue?vue&type=script&lang=js"
import style0 from "./MessageComponent.vue?vue&type=style&index=0&id=06929edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06929edc",
  null
  
)

export default component.exports